import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=7545e86b&scoped=true&"
import script from "./BusinessCard.vue?vue&type=script&lang=ts&"
export * from "./BusinessCard.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=7545e86b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7545e86b",
  null
  
)

export default component.exports